module.exports = __webpack_public_path__ + "static/media/venda_premiada_stihl_2.76dbcca6.jpg";